(function () {
  'use strict';
  var currentCart = null;
  var requestSequence = 0;

  function holders() { return document.querySelectorAll('[data-cart-stock-notices]'); }
  function hideNotices() { holders().forEach(function (element) { element.hidden = true; }); }
  function signature(lines) {
    if (!Array.isArray(lines)) return '';
    var pairs = [];
    for (var index = 0; index < lines.length; index += 1) {
      var line = lines[index];
      if (!line || typeof line.key !== 'string' || !line.key || !Number.isInteger(Number(line.quantity)) || Number(line.quantity) < 1) return '';
      pairs.push([line.key, Number(line.quantity)]);
    }
    return JSON.stringify(pairs.sort(function (a, b) { return a[0].localeCompare(b[0]); }));
  }
  function sourceSignature(element) {
    try { return signature(JSON.parse(element.getAttribute('data-cart-line-snapshot') || '')); }
    catch (error) { return ''; }
  }
  function validStockNote(note, cart) {
    var count = Number(note.getAttribute('data-stock-quantity'));
    var id = note.getAttribute('data-cart-stock-variant');
    if (!Number.isInteger(count) || count < 1 || count > 5 || !note.getAttribute('data-stock-managed') ||
        note.getAttribute('data-stock-policy') !== 'deny' || note.getAttribute('data-stock-available') !== 'true') return false;
    return cart.items.some(function (item) {
      var properties = item.properties || {};
      return String(item.variant_id || item.id) === id && item.gift_card !== true && !properties['Built to order'] &&
        String(item.handle || '').indexOf('carbon-steering-wheel') !== 0;
    });
  }
  function refreshStock(cart) {
    currentCart = cart;
    var sequence = ++requestSequence;
    hideNotices();
    var wanted = signature(cart && cart.items);
    if (!wanted || wanted === '[]' || !holders().length || !window.ThemeCart || !window.ThemeCart.fetchSection) return;
    window.ThemeCart.fetchSection(cart).then(function (html) {
      if (sequence !== requestSequence || wanted !== signature(currentCart && currentCart.items) || !html) return;
      var source = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-stock-notices]');
      if (!source || sourceSignature(source) !== wanted) return;
      var notes = Array.prototype.filter.call(source.querySelectorAll('.cart__stock-note'), function (note) {
        return validStockNote(note, cart);
      });
      holders().forEach(function (element) {
        element.replaceChildren();
        notes.forEach(function (note) { element.appendChild(note.cloneNode(true)); });
        element.setAttribute('data-cart-line-snapshot', source.getAttribute('data-cart-line-snapshot'));
        element.hidden = notes.length === 0;
      });
    }).catch(function () { if (sequence === requestSequence) hideNotices(); });
  }
  document.addEventListener('cart:updated', function (event) { refreshStock(event.detail); });
  window.addEventListener('pageshow', function () {
    if (window.ThemeCart && window.ThemeCart.getCart) refreshStock(window.ThemeCart.getCart());
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && window.ThemeCart && window.ThemeCart.getCart) refreshStock(window.ThemeCart.getCart());
  });
  if (window.ThemeCart && window.ThemeCart.getCart) refreshStock(window.ThemeCart.getCart());
})();
